import React from 'react';

const DailyLogo: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='342'
      height='140'
      viewBox='0 0 342 140'
      fill='none'
    >
      <path
        d='M137.686 116.959C128.726 116.959 121.526 114.932 116.086 110.879C110.646 106.719 107.926 100.959 107.926 93.5991C107.926 86.2392 110.22 80.4792 114.806 76.3193C119.393 72.1593 126.38 69.1727 135.766 67.3594L164.086 61.7594C164.086 55.6795 162.699 51.1462 159.926 48.1595C157.153 45.0662 153.046 43.5196 147.606 43.5196C142.699 43.5196 138.806 44.6929 135.926 47.0396C133.153 49.2795 131.233 52.5328 130.166 56.7995L109.366 55.8395C111.073 46.7729 115.233 39.8396 121.846 35.0397C128.46 30.1331 137.046 27.6797 147.606 27.6797C159.766 27.6797 168.939 30.773 175.126 36.9597C181.419 43.0396 184.566 51.7862 184.566 63.1994V94.2391C184.566 96.4791 184.939 98.0257 185.686 98.8791C186.539 99.7324 187.766 100.159 189.366 100.159H192.086V115.039C191.446 115.252 190.379 115.412 188.886 115.519C187.499 115.626 186.059 115.679 184.566 115.679C181.046 115.679 177.899 115.146 175.126 114.079C172.353 112.906 170.219 110.932 168.726 108.159C167.233 105.279 166.486 101.386 166.486 96.4791L168.246 97.7591C167.393 101.492 165.526 104.852 162.646 107.839C159.873 110.719 156.353 112.959 152.086 114.559C147.819 116.159 143.019 116.959 137.686 116.959ZM141.846 102.079C146.433 102.079 150.379 101.172 153.686 99.3591C156.993 97.5458 159.553 95.0391 161.366 91.8391C163.179 88.6392 164.086 84.8525 164.086 80.4792V75.6793L142.006 80.1592C137.42 81.1192 134.113 82.5592 132.086 84.4792C130.166 86.2925 129.206 88.6925 129.206 91.6791C129.206 94.9858 130.273 97.5458 132.406 99.3591C134.646 101.172 137.793 102.079 141.846 102.079Z'
        fill='url(#paint0_linear_5783_2774)'
      />
      <path
        d='M196.448 115.039V29.5997H216.928V115.039H196.448ZM196.128 18.2398V0H217.408V18.2398H196.128Z'
        fill='url(#paint1_linear_5783_2774)'
      />
      <path
        d='M250.803 115.039C244.616 115.039 239.656 113.439 235.923 110.239C232.189 107.039 230.323 101.919 230.323 94.8791V1.43999H250.803V92.7991C250.803 94.9324 251.336 96.5324 252.403 97.5991C253.576 98.6657 255.176 99.1991 257.203 99.1991H263.443V115.039H250.803Z'
        fill='url(#paint2_linear_5783_2774)'
      />
      <path
        d='M270.902 139.039V123.199H281.782C284.556 123.199 286.582 122.772 287.862 121.919C289.249 121.066 290.316 119.626 291.062 117.599L293.462 111.679H287.542L256.983 29.5997H278.262L299.702 92.4791L320.182 29.5997H341.462L308.022 123.999C306.102 129.332 303.382 133.172 299.862 135.519C296.449 137.865 291.649 139.039 285.462 139.039H270.902Z'
        fill='url(#paint3_linear_5783_2774)'
      />
      <path
        d='M31.4998 26.031C32.6594 26.0311 33.592 26.9894 33.6735 28.1647C34.7016 42.9589 46.3359 54.7784 60.8989 55.8226C62.0559 55.9056 62.9994 56.8527 62.9994 58.0308C62.9994 59.2092 62.0559 60.1563 60.8989 60.2393C46.3359 61.2835 34.7016 73.103 33.6735 87.897C33.592 89.0721 32.6594 90.0304 31.4998 90.0304C30.34 90.0304 29.4074 89.0721 29.3258 87.897C28.2978 73.103 16.6633 61.2835 2.10038 60.2393C0.943496 60.1563 2.45882e-05 59.2092 0 58.0308C0 56.8527 0.94348 55.9056 2.10038 55.8226C16.6633 54.7784 28.2978 42.9589 29.3258 28.1647C29.4074 26.9894 30.34 26.031 31.4998 26.031Z'
        fill='url(#paint4_linear_5783_2774)'
      />
      <path
        d='M43.4781 0.0390621C75.3854 0.0392481 101.244 26.0103 101.244 58.0385C101.244 90.0669 75.3854 116.038 43.4781 116.038H9.72061C7.55975 116.038 6.43964 113.474 7.87688 111.879L20.0301 98.3907H41.2525C63.2243 98.3903 81.0647 80.1342 81.0647 58.0385C81.0647 35.9427 63.2243 17.6867 41.2525 17.6864H20.0301L7.87688 4.1982C6.43944 2.60273 7.55985 0.0390621 9.72061 0.0390621H43.4781ZM74.5345 34.1901C74.625 34.3193 74.7129 34.4504 74.802 34.5807C74.5262 34.1776 74.2457 33.7781 73.9563 33.3854L74.5345 34.1901ZM62.4145 22.7215C62.6949 22.8952 62.9735 23.0714 63.2494 23.2517L62.4145 22.7215C62.1341 22.5478 61.8515 22.3767 61.5668 22.2098L62.4145 22.7215ZM43.3521 16.7411C44.0186 16.7757 44.6808 16.8265 45.3384 16.8934C44.3376 16.7915 43.3261 16.7265 42.3053 16.7L43.3521 16.7411Z'
        fill='url(#paint5_linear_5783_2774)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5783_2774'
          x1='169.998'
          y1='115.039'
          x2='169.998'
          y2='-1.45998'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFD601' />
          <stop offset='0.5' stopColor='#F7A1B3' />
          <stop offset='1' stopColor='#97D5FC' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5783_2774'
          x1='169.998'
          y1='115.039'
          x2='169.998'
          y2='-1.45998'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFD601' />
          <stop offset='0.5' stopColor='#F7A1B3' />
          <stop offset='1' stopColor='#97D5FC' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_5783_2774'
          x1='169.998'
          y1='115.039'
          x2='169.998'
          y2='-1.45998'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFD601' />
          <stop offset='0.5' stopColor='#F7A1B3' />
          <stop offset='1' stopColor='#97D5FC' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_5783_2774'
          x1='169.998'
          y1='115.039'
          x2='169.998'
          y2='-1.45998'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFD601' />
          <stop offset='0.5' stopColor='#F7A1B3' />
          <stop offset='1' stopColor='#97D5FC' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_5783_2774'
          x1='169.998'
          y1='115.039'
          x2='169.998'
          y2='-1.45998'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFD601' />
          <stop offset='0.5' stopColor='#F7A1B3' />
          <stop offset='1' stopColor='#97D5FC' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_5783_2774'
          x1='169.998'
          y1='115.039'
          x2='169.998'
          y2='-1.45998'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFD601' />
          <stop offset='0.5' stopColor='#F7A1B3' />
          <stop offset='1' stopColor='#97D5FC' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DailyLogo;
